import { getRoles, clearLocalStorage } from "@/services/config";
import KeycloakService from "@/services/keycloak/keycloakService";

export function guardUserClient(to: any, from: any, next: any) {
    if(getRoles() == "USER" || getRoles() == "CLIENT"){ 
        next()
    } else {
        KeycloakService.CallLogout();
        clearLocalStorage();
    }
}